// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
export const ClarityTranslationFragmentDoc = gql`
    fragment clarityTranslation on StoneClarityTranslation {
  name
}
    `;